import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { listTemplates } from "@/lib/api";
import { fmtDateTime } from "@/lib/formatters";

export function TemplatesIndex() {
  const { data: templates, isLoading } = useQuery({
    queryKey: ["templates"],
    queryFn: listTemplates,
  });

  return (
    <div className="panel">
      <div className="panel-h">
        <h3>Email templates</h3>
      </div>
      <div className="tbl-wrap">
        <table className="tbl">
          <thead><tr><th>Naam</th><th>Slug</th><th>Trigger</th><th>Status</th><th>Bewerkt</th><th></th></tr></thead>
          <tbody>
            {isLoading && <tr><td colSpan={6} className="empty"><span className="spinner" /> Laden…</td></tr>}
            {(templates ?? []).map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td>
                <td><code style={{ fontFamily: "var(--f-mono)", color: "var(--c-orange)" }}>{t.slug}</code></td>
                <td>{t.trigger ?? "—"}</td>
                <td><span className={`pill-st ${t.active ? "sent" : "draft"}`}>{t.active ? "Actief" : "Inactief"}</span></td>
                <td>{fmtDateTime(t.updated_at)}</td>
                <td>
                  <Link to={`/templates/${t.slug}`} className="btn-mini">Bewerk</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
